import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import Icon from '../../Icon';
import Pager from '../../Pager';
import DeleteTrackerButton from './DeleteTrackerButton';
import TrackerStatus from './TrackerStatus';
import TrackerSurveyState from './TrackerSurveyState';
import {TRACKERS_PAGE_SIZE} from '../../../constants';

const TrackersList = ({onDelete, page, trackers, total, onPageChange}) => {
    const pages = Math.ceil(total / TRACKERS_PAGE_SIZE);

    if (!trackers.length) {
        return null;
    }
    return (
        <table className="table table-sm">
            <thead>
                <tr>
                    <th>
                        <FormattedMessage {...messages.trackers.list.email} />
                    </th>
                    <th>
                        <FormattedMessage {...messages.trackers.list.mobile} />
                    </th>
                    <th>
                        <FormattedMessage {...messages.trackers.list.survey} />
                    </th>
                    <th>
                        <FormattedMessage {...messages.trackers.list.status} />
                    </th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {trackers.map((tracker) => (
                    <tr key={tracker.url}>
                        <td>{tracker.email}</td>
                        <td>{tracker.mobile}</td>
                        <td>
                            <TrackerSurveyState tracker={tracker} />
                        </td>
                        <td>
                            <TrackerStatus items={tracker.messages} />
                        </td>
                        <td>
                            <DeleteTrackerButton onDelete={onDelete} item={tracker}>
                                <Icon icon="trash" />
                            </DeleteTrackerButton>
                        </td>
                    </tr>
                ))}
            </tbody>
            <tfoot>
                <tr>
                    <td colSpan={5}>
                        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                            <Pager
                                className="justify-content-end"
                                pages={pages}
                                current={page}
                                onClick={onPageChange}
                            />
                        </div>
                    </td>
                </tr>
            </tfoot>
        </table>
    );
};

export default TrackersList;
